<template>
    <div class="container">
        <div class="page_not_found">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <h2>Oeps… <br/> er ging iets mis</h2>
                        <img src="/static/img//smileys/smiley-404.png" />
                        <p>De pagina die je probeerde te openen
                            bestaat niet. Gebruik de navigatie bovenin
                            of ga terug naar de vorige pagina.</p>
                        <router-link :to="{ name: 'evaluation-students' }" class="button--cta">Ga terug</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component
    export default class PageNotFound extends Vue {
        name = 'page_not_found';
    }

    Vue.component('page_not_found', PageNotFound);
</script>



// WEBPACK FOOTER //
// src/pages/PageNotFound.vue